import React from "react";
import { Container, Row, Col, Card, Button } from "react-bootstrap";
import NavBar from "../Components/NavBar/NavBar";
import Footer from "../Components/Footer/Footer";
import { Helmet } from "react-helmet";

const MobileAppDevelopment = () => {
  const expertiseItems = [
    {
      title: "Native App Development",
      description:
        "High-performance apps tailored for Android (Java/Kotlin) and iOS (Swift/Objective-C).",
    },
    {
      title: "Cross-Platform Development",
      description:
        "Cost-effective mobile solutions built with Flutter, React Native, or Xamarin.",
    },
    {
      title: "UI/UX Design Excellence",
      description:
        "Intuitive, responsive, and user-centered designs to drive engagement.",
    },
    {
      title: "API & Backend Integration",
      description:
        "Secure integration with cloud services, third-party systems, and databases.",
    },
    {
      title: "Enterprise Mobile Solutions",
      description:
        "Robust internal apps for logistics, operations, reporting, and communication.",
    },
    {
      title: "E-Commerce & Customer Apps",
      description:
        "Mobile apps for shopping, loyalty programs, bookings, payments, and more.",
    },
  ];

  return (
    <>
      <Helmet>
        <title>Mobile App Design & Development | Dhanam Infosys</title>
        <meta
          name="description"
          content="Empower your business with intuitive mobile apps. We build Android, iOS, and cross-platform apps tailored for performance and user experience."
        />
      </Helmet>

      <NavBar />

      {/* Hero Section */}
      <div className="about-hero py-5 text-white text-center">
        <Container>
          <h1>Mobile App Design and Development</h1>
          <p className="lead">
            Transform Ideas into Intuitive, Scalable Mobile Experiences
          </p>
        </Container>
      </div>

      <Container className="py-5">
        <p>
          At <strong>Dhanam Information Systems</strong>, we create custom
          mobile applications that empower businesses to innovate, grow, and
          engage their customers more effectively. Whether you're launching a
          consumer-facing app or a secure enterprise mobility solution, we
          deliver powerful mobile experiences across Android, iOS, and
          cross-platform environments.
        </p>

        {/* Expertise Cards */}
        <h5 className="text-primary mt-5 mb-4 text-center">🔹 Our Expertise</h5>
        <Row className="mb-5">
          {expertiseItems.map((item, index) => (
            <Col md={4} key={index} className="mb-4">
              <Card className="h-100 shadow-sm">
                <Card.Body>
                  <Card.Title className="text-success">✔ {item.title}</Card.Title>
                  <Card.Text>{item.description}</Card.Text>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>

        {/* Process Section */}
        <h5 className="text-primary mb-3">🔹 Our Process</h5>
        <ul className="mb-5 fs-5">
          <li>✔ <strong>Discovery & Ideation –</strong> Align with your business goals</li>
          <li>✔ <strong>Wireframing & UI Design –</strong> Craft intuitive, branded interfaces</li>
          <li>✔ <strong>Development & Testing –</strong> Build robust, responsive apps</li>
          <li>✔ <strong>Deployment & Maintenance –</strong> Publish, monitor, and evolve</li>
        </ul>

        {/* Why Dhanam Section */}
        <h5 className="text-primary mb-3">🔹 Why Dhanam?</h5>
        <ul className="mb-5 fs-5">
          <li>✔ Experienced Android & iOS developers</li>
          <li>✔ Agile delivery with quick turnaround</li>
          <li>✔ Post-launch support & app store optimization</li>
          <li>✔ Data security, scalability, and compliance</li>
        </ul>

        {/* Brochure + CTA */}
        <Row className="my-5">
          <Col md={6}>
            <Card className="shadow-sm">
              <Card.Body>
                <Card.Title className="text-success">📱 Brochure Snapshot</Card.Title>
                <ul>
                  <li>✔ Custom Android & iOS App Development</li>
                  <li>✔ Flutter & React Native Cross-Platform Solutions</li>
                  <li>✔ Engaging UI/UX Design</li>
                  <li>✔ Scalable API & Backend Integration</li>
                  <li>✔ Secure, Enterprise-Grade Mobility Solutions</li>
                </ul>
              </Card.Body>
            </Card>
          </Col>
          <Col md={6} className="d-flex align-items-center">
            <div>
              <h5 className="fw-bold text-dark">
                Go mobile-first with confidence.
              </h5>
              <p>
                Let Dhanam Information Systems build a custom mobile app that
                fits your business vision and your users’ needs.
              </p>
              <Button variant="primary" href="mailto:info@dhanaminfosys.com">
                📩 Contact Us
              </Button>
            </div>
          </Col>
        </Row>
      </Container>

      <Footer />

      <style jsx>{`
        .about-hero {
          background-color: rgb(11, 22, 63);
        }

        ul {
          list-style: none;
          padding-left: 0;
        }

        ul li::before {
          margin-right: 10px;
          color: green;
        }
      `}</style>
    </>
  );
};

export default MobileAppDevelopment;
